import { useContext, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "@context/user";

// Keeps the URL's :publisherId honest against the known publisher list — bounces
// back to publisher 0's overview if it doesn't match anything (bad/stale link,
// hand-edited URL, ...), and otherwise keeps the topbar switcher in sync
// with whichever valid publisher the URL points at.
const usePublisherRouteGuard = () => {
    const { publisherId } = useParams();
    const navigate = useNavigate();
    const { publishers, activePublisherId, setActivePublisherId } = useContext(UserContext);
    const isValid = publishers.some((publisher) => publisher.id === publisherId);

    useEffect(() => {
        if (!publishers.length) return;
        if (!isValid) {
            navigate(`/publisher/${publishers[0].id}/overview`, { replace: true });
            return;
        }
        if (publisherId !== activePublisherId) setActivePublisherId(publisherId);
    }, [publishers, isValid, publisherId]); // eslint-disable-line react-hooks/exhaustive-deps

    return { publisherId, isValid };
};

export default usePublisherRouteGuard;
